export default __webpack_public_path__ + "static/media/yimei.c6dbda11.jpg";